/* eslint-disable @typescript-eslint/no-explicit-any */
import { Dispatch } from 'react';

import { DefyStatusManager } from '../services/manager';
import { answerChallengePlayer, cancelSubcription, getDefyById, joinDefyAdd } from '../services/defy';
import { defyActions, defyResponseActions } from './definition';
import { IAnswerDefy, IJoinDefy } from '../interfaces/defy';

function defyIsLoading() {
    return {
        type: defyActions.DEFY_IS_LOADING,
    };
}

const defyReset = () => {
    return {
        type: defyActions.DEFY_RESET,
    };
};

function defyError(e: string) {
    return {
        type: defyActions.DEFY_ERROR,
        error: e,
        data: e,
    };
}

function defySet(defys: any) {
    return {
        type: defyActions.DEFY,
        data: defys,
    };
}

function defyResponseIsLoading() {
    return {
        type: defyResponseActions.DEFY_IS_LOADING,
    };
}

function defyResponseError(e: string) {
    return {
        type: defyResponseActions.DEFY_ERROR,
        error: e,
        data: e,
    };
}

function defyResponseSet(defys: any) {
    return {
        type: defyResponseActions.DEFY,
        data: defys,
    };
}

const defyResetResponse = () => {
    return {
        type: defyResponseActions.DEFY_RESET,
    };
};
/**
 * Reducer to rest a defys
 * @param values Data to reset defys
 */
export const resetStateDefy = () => {
    return async (dispatch: Dispatch<any>): Promise<void> => {
        dispatch(defyReset());
    };
};

/**
 * Reducer to rest a defys
 * @param values Data to reset defys
 */
export const resetStateDefyResponse = () => {
    return async (dispatch: Dispatch<any>): Promise<void> => {
        dispatch(defyResetResponse());
    };
};

/**
 * Reducer to rest a defys
 * @param values Data to reset defys
 */
export const resetDefyReset = () => {
    return async (dispatch: Dispatch<any>): Promise<void> => {
        dispatch(defyReset());
    };
};

/**
 * Reducer to reset Defys
 * @param values Values to reset defys
 */
export const resetDefy = () => {
    return async (dispatch: Dispatch<any>): Promise<void> => {
        dispatch(defyReset());
    };
};

/**
 * Reducer to get a defy by id
 * @param id Id of defy to find
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const fetchDefyById = (id: string, statusUser: boolean, team?: any, origin?: string) => {
    return async (dispatch: Dispatch<any>): Promise<void> => {
        dispatch(defyIsLoading());
        try {
            const response = await getDefyById(id, statusUser);
            /*let response: any = {};
            //mock con ambos equipos disponibles
            response = mock.find((item) => item?.data.id === id);
            */
            //ESTO ES PARA SABER SI ES TEAM1 O TEAM2
            response.data.team = team;
            //console.log({ origin });
            if (response?.statusCode === DefyStatusManager.DEFY_BY_ID && response.data) {
                console.log('entre*****', { response });
                let newData = response.data;
                //si alguno de los dos equipos esta pendiente para pagar se muestra el desafio sin ese equipo para que otro lo pueda ocupar
                if (newData.challengerStatusPaid === 'NOT_PAID' && origin === 'challengeDetail') {
                    newData = {
                        ...newData,
                        challengedParticipate: true,
                        challengerStatus: 'WAITING_TO_ACCEPT',
                        challengerStatusPaid: 'PENDING_PAYMENT',
                        challengerTeam: {
                            transactionCode: '',
                            transactionStatus: '',
                        },
                        challengerTeamId: null,
                    };
                }
                if (newData.challengedStatusPaid === 'NOT_PAID' && origin === 'challengeDetail') {
                    newData = {
                        ...newData,
                        challengedParticipate: true,
                        challengedStatus: 'WAITING_TO_ACCEPT',
                        challengedStatusPaid: 'PENDING_PAYMENT',
                        challengedTeam: {
                            transactionCode: '',
                            transactionStatus: '',
                        },
                        challengedTeamId: null,
                    };
                }
                console.log({ newData });
                dispatch(defySet({ ...response, data: newData }));
            } else {
                dispatch(defyError('Could not get defy'));
            }
        } catch (error: any) {
            console.log({ error });
            dispatch(defyError('No se pudo obtener el defy'));
        }
    };
};

/**
 * Reducer  join defy
 * @param values Data to create a join defy
 */
export const joinDefy = (values: IJoinDefy) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return async (dispatch: Dispatch<any>): Promise<void> => {
        try {
            dispatch(defyResponseIsLoading());
            let newValue = values;
            if (values.challengerTeamId === '' && values.challengedTeamId !== '') {
                console.log('entre joinDefy');
                newValue = { ...values, challengerTeamId: values.challengedTeamId, challengedTeamId: '' };
            }
            console.log('aqui*****', { values, newValue });
            const defy = await joinDefyAdd(newValue);
            dispatch(defyResponseSet(defy));
        } catch (error: any) {
            dispatch(defyResponseError('No se pudo unir al desafío'));
        }
    };
};

/**
 * Reducer  answerChallenge defy
 * @param values Data to create a answerChallenge defy
 */
export const answerChallenge = (values: IAnswerDefy) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return async (dispatch: Dispatch<any>): Promise<void> => {
        try {
            dispatch(defyResponseIsLoading());
            const defy = await answerChallengePlayer(values);
            dispatch(defyResponseSet(defy));
        } catch (error: any) {
            dispatch(defyResponseError('No se pudo responser al desafío'));
        }
    };
};

/**
 * Reducer  add guest defy
 * @param values Data to create a add guest defy
 */
export const defyCancelSubcription = (values: string) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return async (dispatch: Dispatch<any>): Promise<void> => {
        try {
            dispatch(defyIsLoading());
            const defy = await cancelSubcription(values);
            dispatch(defySet(defy));
        } catch (error: any) {
            if (error.response && error.response.data) {
                if (error.response.data?.statusCode === 'CHALLENGES_NOT_FOUND') {
                    dispatch(defyError('desafío no existe'));
                } else {
                    dispatch(defyError('No se pudo cancelar el desafío'));
                }

                return;
            } else {
                dispatch(defyError('No se pudo cancelar al desafío'));
                return;
            }
        }
    };
};
